import { INewbuilding } from '../../types/newbuilding';

export function getNewbuildingUrl(newbuilding: INewbuilding) {
  return newbuilding.url;
}
